import { useEffect, useState } from 'react';
import useSWR from 'swr';

import { Label } from '@/components/ui/label';
import { Select } from '@/components/ui/select';

type CheckpointData = {
  id: string;
  name: string;
  __v: number;
};

type CheckpointSelectorProps = {
  onChange: (data: { id: string; name: string }) => void;
};

const STORAGE_KEY = 'scanner.selectedCheckpointId';

const CheckpointSelector = ({ onChange }: CheckpointSelectorProps) => {
  const [value, setValue] = useState<string>('');
  const { data } = useSWR<{ checkpoints: CheckpointData[] }>(
    '/api/checkpoints',
  );

  useEffect(() => {
    if (
      data &&
      data.checkpoints.length >= 1 &&
      !data.checkpoints.map((c) => c.id).includes(value)
    ) {
      const storedId = localStorage.getItem(STORAGE_KEY);
      const stored = data.checkpoints.find((c) => c.id === storedId);
      const { id, name } = stored ?? data.checkpoints[0];
      setValue(id);
      onChange({ id, name });
    }
  }, [data]);

  return (
    <div className="my-6 space-y-2">
      <Label htmlFor="checkpoint-selector">Ausgewählter Checkpoint</Label>
      <Select
        id="checkpoint-selector"
        value={value}
        onChange={(e) => {
          if (!data) {
            return;
          }

          const newValue = e.target.value;
          setValue(newValue);
          localStorage.setItem(STORAGE_KEY, newValue);
          onChange({
            id: newValue,
            name: data.checkpoints.find((c) => c.id === newValue)
              ?.name as string,
          });
        }}
      >
        {!data && <option value="">Lädt...</option>}
        {data && data.checkpoints.length === 0 && (
          <option value="">Keine Checkpoints vorhanden</option>
        )}
        {data &&
          data.checkpoints.map((cp) => (
            <option key={cp.id} value={cp.id}>
              {cp.name}
            </option>
          ))}
      </Select>
    </div>
  );
};

export default CheckpointSelector;
